import {
  deleteUserSelection,
  DownloadSource,
  ElementDownload,
  KpkApiGetDownloadRequestsParams,
  KpkApiGetDownloadRequestsResult,
  KpkApiOrientationContactSheet,
  KpkApiPostDownloadRequestsParams,
  KpkApiUser,
} from "@keepeek/api-client";
import { KpkMedia } from "@keepeek/commons";
import { KpkContactSheet } from "@keepeek/refront-components";
import { AxiosInstance, AxiosResponse } from "axios";
import { TFunction } from "i18next";
import { ProviderContext, SnackbarKey } from "notistack";

import logger from "../../lib/logger-utils";
import { downloadFileRequest } from "../downloadManager/utils";

export async function generateContactSheet(
  axiosInstance: AxiosInstance,
  postDownloadRequests: (
    params: KpkApiPostDownloadRequestsParams,
  ) => Promise<AxiosResponse> | Promise<undefined>,
  getDownloadRequests: (
    params: KpkApiGetDownloadRequestsParams,
  ) => Promise<AxiosResponse<KpkApiGetDownloadRequestsResult>> | Promise<undefined>,
  kpkContactSheetId: KpkContactSheet["id"],
  snackBar: ProviderContext,
  t: TFunction<"translation", undefined>,
  selectionId: string | null,
  orientation: KpkApiOrientationContactSheet,
  user: KpkApiUser,
  elementsId: KpkMedia["id"][],
): Promise<void> {
  const { enqueueSnackbar, closeSnackbar } = snackBar;

  const elementDownloads: ElementDownload[] = [];
  const downloadSources: DownloadSource[] = [];
  downloadSources.push({
    from: {
      href: `${axiosInstance.defaults.baseURL}/api/dam/contact-sheets/${kpkContactSheetId}`,
    },
    additionalExportParameters: { orientation },
  });
  const elementDownload: ElementDownload = {
    mediaIds: elementsId,
    downloadSources,
  };
  elementDownloads.push(elementDownload);

  try {
    // Notify the user for UX Purpose
    const snackPrep: SnackbarKey = enqueueSnackbar(t("contact-sheet.status.processing.label"), {
      persist: true,
      variant: "info",
      key: "preparingDownloadMsg",
    });

    // Create the download request
    await downloadFileRequest(
      postDownloadRequests,
      getDownloadRequests,
      elementDownloads,
      closeSnackbar,
      snackPrep,
      enqueueSnackbar,
      t,
      false,
      undefined,
    );
  } catch (error) {
    // In case of fail, first, close all snacks
    closeSnackbar();

    // For everything else, tell the user that something went wrong
    enqueueSnackbar(t("contact-sheet.status.error.label"), {
      variant: "error",
      persist: false,
    });
    logger.warn("contact-sheet", error);
  }
  // Delete the user selection
  if (selectionId) {
    try {
      // don't need any feedback on the call
      // it's only for a cleaner Back-end state
      await deleteUserSelection(axiosInstance, {
        userId: user.id,
        selectionId,
        axiosRequestConfig: { handleErrorLocally: true },
      });
    } catch (error) {
      logger.info("contactSheetDeleteSelection", error);
    }
  }
}
